import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function EnquiriesHistory({ keyword, searchDate, activeTab }) {
  const { reservationLoading, enquiriesHistory } = useContext(AppContext);
  const [displayList, setDisplayList] = useState(null);

  useEffect(() => {
    if (!enquiriesHistory) return;
    setDisplayList(enquiriesHistory);
  }, [enquiriesHistory]);

  useEffect(() => {
    filterData(searchDate, keyword);
  }, [keyword, activeTab, enquiriesHistory, searchDate]);

  const filterData = (date, keyword) => {
    let filteredData = enquiriesHistory;

    if (date) {
      const today = new Date(date);
      filteredData = filteredData.filter((data) => {
        const bookingDate = new Date(data.bookingTime);
        return (
          bookingDate.getFullYear() === today.getFullYear() &&
          bookingDate.getMonth() === today.getMonth() &&
          bookingDate.getDate() === today.getDate()
        );
      });
    }

    if (keyword && keyword.length !== 0) {
      filteredData = filteredData.filter(
        (item) =>
          item.name.toLowerCase().includes(keyword.toLowerCase()) ||
          item.email.toLowerCase().includes(keyword.toLowerCase()) ||
          item.formattedID.toLowerCase().includes(keyword.toLowerCase()) ||
          item.phone.includes(keyword)
      );
    }

    setDisplayList(filteredData);
  };

  return (
    <Fragment>
      <EnquiryListPanel
        title="History"
        items={displayList}
        loading={reservationLoading}
        emptyMessage="No Enquiries"
        showStatus
      />
    </Fragment>
  );
}

export default EnquiriesHistory;
